// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3XJHF{display:-ms-flexbox;display:flex;color:#595757;margin-bottom:1.5rem;overflow-x:auto;font-size:18px;font-weight:500;line-height:25px;font-family:var(--heading-font);letter-spacing:.5px}._3XJHF._2ZJXO{border-bottom:2px solid #dcdddd}.IlX0I{-ms-flex-negative:0;flex-shrink:0;cursor:pointer;padding:.3125rem 0;margin-right:2rem}._2LK-Y{color:#231815;border-bottom:2px solid #231815}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"tabs": "_3XJHF",
	"noSticky": "_2ZJXO",
	"tab": "IlX0I",
	"selectedTab": "_2LK-Y"
};
module.exports = exports;
